import { Channel } from "@/config/channel"
import { triggerSurvey, TriggerType } from "./survey-utils"

export const SandsivSurveyIdSnai = {
  ThankYouPage: 15,
  Home: 18,
  Bonus: 22,
  NameSurname: 23,
  PdvSignup: 26,
  TaxCode: 24,
  ResidenceAddress: 27,
  Contacts: 28,
  AccessData: 29,
  SelectDocument: 30,
  DocumentData: 31,
  TopupLimits: 32,
  TermsAndConditions: 33,
  RecapOcr: 34,
} as const

type SandsivSurveyIdSnaiType =
  (typeof SandsivSurveyIdSnai)[keyof typeof SandsivSurveyIdSnai]

const apiUrl = "https://snai-digi.sandsiv.com"

export function triggerSurveySnai(
  surveyId: SandsivSurveyIdSnaiType,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
  accountId?: string | null,
) {
  return triggerSurvey(
    apiUrl,
    surveyId,
    channel,
    triggerType,
    ipAddress,
    accountId,
  )
}

export function triggerSurveyBasedOnPathnameSnai(
  pathname: string,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
) {
  const surveyId = getSurveyId(pathname)
  if (surveyId == null) return false
  return triggerSurvey(apiUrl, surveyId, channel, triggerType, ipAddress)
}

function getSurveyId(pathname: string): SandsivSurveyIdSnaiType | null {
  switch (pathname) {
    case "/":
      return SandsivSurveyIdSnai.Home
    case "/nome-cognome":
      return SandsivSurveyIdSnai.NameSurname
    case "/codice-fiscale":
      return SandsivSurveyIdSnai.TaxCode
    case "/indirizzo-residenza":
      return SandsivSurveyIdSnai.ResidenceAddress
    case "/contatti":
      return SandsivSurveyIdSnai.Contacts
    case "/dati-di-accesso":
      return SandsivSurveyIdSnai.AccessData
    case "/bonus":
      return SandsivSurveyIdSnai.Bonus
    case "/dati-documento":
      return SandsivSurveyIdSnai.DocumentData
    case "/limiti-ricarica":
      return SandsivSurveyIdSnai.TopupLimits
    case "/termini-e-condizioni":
    case "/termini-e-condizioni-ocr":
      return SandsivSurveyIdSnai.TermsAndConditions
    case "/riepilogo-dati-ocr":
      return SandsivSurveyIdSnai.RecapOcr
    case "/registrazione-pdv":
      return SandsivSurveyIdSnai.PdvSignup
    case "/seleziona-documento/cliente":
      return SandsivSurveyIdSnai.SelectDocument
    default:
      return null
  }
}
